import { z } from 'zod';

const defaultBooleanSchema = z.boolean().catch(false);

export const featureSetSchema = z.object({
    'ag-ui-chat': defaultBooleanSchema,
    'ag-ui-generative-ui': defaultBooleanSchema,
    'agent-attributions': defaultBooleanSchema,
    'ai-chat': defaultBooleanSchema,
    'allow-drag-and-drop-of-jsa-cards': defaultBooleanSchema,
    'announcements-enabled': defaultBooleanSchema,
    'auto-expand-compare-view-in-agent': defaultBooleanSchema,
    'career-framework-job-architecture-links': defaultBooleanSchema,
    'chat-attachments': defaultBooleanSchema,
    'co-studio-workspace': defaultBooleanSchema,
    'company-home': defaultBooleanSchema,
    'compare-job-roles': defaultBooleanSchema,
    'create-jsa-entities-with-ai': defaultBooleanSchema,
    'demo-menu': defaultBooleanSchema,
    'edit-change-proposal-in-agent': defaultBooleanSchema,
    'enhanced-lvl-framework-edit': defaultBooleanSchema,
    'generate-all-job-roles': defaultBooleanSchema,
    'growth-company-goals': defaultBooleanSchema,
    'growth-goals': defaultBooleanSchema,
    'hide-diff-view-if-compare-available': defaultBooleanSchema,
    'job-architecture-v-2': defaultBooleanSchema,
    'jsa-copy-all-roles-to-levels': defaultBooleanSchema,
    'jsa-generation-v-2': defaultBooleanSchema,
    'jsa-review-mode': defaultBooleanSchema,
    'keyboard-shortcuts': defaultBooleanSchema,
    'languages-organization-settings': defaultBooleanSchema,
    'leveling-framework-menu-item': defaultBooleanSchema,
    'new-dashboard': defaultBooleanSchema,
    'new-job-profile-api': defaultBooleanSchema,
    'onboarding-tile': defaultBooleanSchema,
    'personal-home': defaultBooleanSchema,
    'position-alignment': defaultBooleanSchema,
    'position-management-v-2': defaultBooleanSchema,
    'show-deployed-version': defaultBooleanSchema,
    'show-skill-stats-in-detail': defaultBooleanSchema,
    'skill-bulk-removal': defaultBooleanSchema,
    'skill-detection-preferences': defaultBooleanSchema,
    'skills-section': defaultBooleanSchema,
    'structured-profile-tasks': defaultBooleanSchema,
    'task-automation-recipes': defaultBooleanSchema,
    'terminology-settings': defaultBooleanSchema,
    'workspace-navigation': defaultBooleanSchema,
    'generate-all-families-clusters-roles-button': defaultBooleanSchema,
});

export type FeatureSet = z.infer<typeof featureSetSchema>;
export type FeatureName = keyof typeof featureSetSchema.shape;

export type FeatureFlagService = {
    readonly initialize: () => Promise<FeatureSet>;
    readonly isFeatureFlagEnabled: (featureFlagName: FeatureName) => boolean;
};
